module.exports = __webpack_public_path__ + "static/img/en6.1a5a581.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/contact/en6.jpg
// module id = 7Kcs
// module chunks = 1